import type { IconSvgObject } from './types';

const WifiZeroIcon: IconSvgObject = [
  ["path", { d: "M12.125 19.25H12M12.25 19.25C12.25 19.3881 12.1381 19.5 12 19.5C11.8619 19.5 11.75 19.3881 11.75 19.25C11.75 19.1119 11.8619 19 12 19C12.1381 19 12.25 19.1119 12.25 19.25Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default WifiZeroIcon;
